module.exports = __webpack_public_path__ + "fonts/fs_lola-light-webfont.1ad64c54.woff";